.common-button {
  user-select: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: none;
  color: var(--color-on-primary-container);
  background-color: var(--color-primary-container);
  padding: 12px 24px;
  border-radius: var(--border-radius, 20px);
  box-sizing: border-box;
  position: relative;
  gap: 8px;
  white-space: nowrap;
  line-height: 20px;
  letter-spacing: 0.1px;
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 500;
  box-shadow: var(--elevation-1);
  transition: box-shadow 0.2s ease-in-out 0s;
  height: 44px;
  .common-button-icon {
    font-size: 18px;
  }
}
